// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "12e42f71143cc907b4ff02328ae310256eb3a7fc/static/css/" + chunkId + "." + "0b63a1be" + ".chunk.css";
};